import { NotFoundImageProps } from './notFoundImage.types'

const NotFoundImage = ({ width = 200, height = 200, className }: NotFoundImageProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle opacity="0.5" cx="100.5" cy="100" r="100" fill="#E6E9ED" />
      <g filter="url(#filter0_d_1124_43880)">
        <path
          d="M41.5 60C41.5 58.8954 42.3954 58 43.5 58H157.5C158.605 58 159.5 58.8954 159.5 60V70H41.5V60Z"
          fill="#464B52"
        />
        <path
          d="M41.5 70H159.5V140C159.5 141.105 158.605 142 157.5 142H43.5C42.3954 142 41.5 141.105 41.5 140V70Z"
          fill="white"
        />
        <rect width="14" height="4" rx="2" transform="matrix(1 0 0 -1 93.5 114)" fill="#C9CED4" />
        <rect width="5" height="5" rx="2.5" transform="matrix(1 0 0 -1 85.5 102)" fill="#C9CED4" />
        <rect width="5" height="5" rx="2.5" transform="matrix(1 0 0 -1 110.5 102)" fill="#C9CED4" />
      </g>
      <rect width="4" height="4" rx="2" transform="matrix(1 0 0 -1 45.5 66)" fill="#E37570" />
      <rect width="4" height="4" rx="2" transform="matrix(1 0 0 -1 52.5 66)" fill="#EFBA0F" />
      <rect width="4" height="4" rx="2" transform="matrix(1 0 0 -1 59.5 66)" fill="#4ACC82" />
      <path
        d="M176.929 57.7143C176.929 67.4976 168.998 75.4286 159.214 75.4286C149.431 75.4286 141.5 67.4976 141.5 57.7143C141.5 47.9309 149.431 40 159.214 40C168.998 40 176.929 47.9309 176.929 57.7143Z"
        fill="#5981E3"
      />
      <path
        d="M160.871 61.8831H157.458L156.741 48.2026H161.588L160.871 61.8831ZM156.684 66.6727C156.684 65.7932 156.923 65.1814 157.401 64.8372C157.879 64.4739 158.462 64.2923 159.15 64.2923C159.819 64.2923 160.393 64.4739 160.871 64.8372C161.349 65.1814 161.588 65.7932 161.588 66.6727C161.588 67.514 161.349 68.1259 160.871 68.5083C160.393 68.8716 159.819 69.0532 159.15 69.0532C158.462 69.0532 157.879 68.8716 157.401 68.5083C156.923 68.1259 156.684 67.514 156.684 66.6727Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1124_43880"
          x="31.5"
          y="56"
          width="138"
          height="104"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="6"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_1124_43880"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1124_43880" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1124_43880"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default NotFoundImage
